import styles from "./Checkbox.module.scss";
import { Controller } from "react-hook-form";
import type { Control, RegisterOptions, UseFormRegister } from "react-hook-form";
import withLabelAndError from "../withLabelAndError";

export interface CheckBoxProps {
  name: string;
  placeholder?: string;
  control?: Control<any>;
  register?: UseFormRegister<any>;
  validations?: RegisterOptions;
  [key: string]: unknown;
}

const Checkbox = (props: CheckBoxProps) => {
  const { control, register, validations, name, placeholder, ...rest } = props;

  const renderInput = (field?: Record<string, unknown>) => (
    <div className={styles.checkboxWrapper}>
      <input
        type="checkbox"
        {...field}
        {...rest}
        id={name}
        className={styles.checkbox}
        placeholder={placeholder}
      />
    </div>
  );

  if (control) {
    return (
      <Controller
        control={control}
        rules={validations ?? {}}
        name={name}
        render={({ field }) =>
          renderInput({
            ...field,
            checked: field.value,
            onChange: field.onChange,
          })
        }
      />
    );
  } else {
    const field = register ? register(name, validations) : {};
    return renderInput(field);
  }
};

const CheckboxWithLabelAndError = withLabelAndError(Checkbox);

export default CheckboxWithLabelAndError;
export { Checkbox };
